var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNurse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 117.438,
    viewBox: "0 0 232 117.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38327",
    "data-name": "Group 38327",
    transform: "translate(-1077 -430.563)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7114",
    "data-name": "Rectangle 7114",
    width: 232,
    height: 117,
    rx: 5,
    transform: "translate(1077 431)",
    fill: "#191bc3",
    opacity: 0.781
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37382",
    "data-name": "Group 37382",
    transform: "translate(1237.429 430.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65014",
    "data-name": "Path 65014",
    d: "M2960.331,208s-24.779-6.1-37.445-18.324c-3.893-3.754-6.566-8.175-6.763-13.531-.17-4.475,1.873-9.818,7.208-15.7,6.444-7.1,14.2-31.109,14.726-38.663,1.739-24.724-38.628-31.223-38.628-31.223h60.866V208Z",
    transform: "translate(-2889.428 -90.562)",
    fill: "#f9db8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65016",
    "data-name": "Path 65016",
    d: "M2960.331,208s-24.779-6.1-37.445-18.324c-3.893-3.754-6.566-8.175-6.763-13.531-.17-4.475,1.873-9.818,7.208-15.7,6.444-7.1,14.2-31.109,14.726-38.663,1.739-24.724-38.628-31.223-38.628-31.223h60.866V208Z",
    transform: "translate(-2899.428 -90.562)",
    fill: "#f9db8f",
    opacity: 0.28
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurse);
export default __webpack_public_path__ + "static/media/Nurse.a44f2d627ac31b4544ff785d10f8f13f.svg";
export { ForwardRef as ReactComponent };